export default __webpack_public_path__ + "static/media/welcome-2.495dc33a.png";